import { Component, HostBinding, inject } from '@angular/core';

import { DeviceService } from '@frontend/vanilla/core';

@Component({
    selector: 'ms-skeleton-betslip',
    templateUrl: './skeleton-betslip.component.html',
})
export class SkeletonBetslipComponent {
    device = inject(DeviceService);

    @HostBinding('class') className = 'sk-betslip-container sk-b-rad5 sk-p-12';
}
